export default __webpack_public_path__ + "static/media/home-interior-design-portfolio-img01.a523c444.jpg";